import React, { useEffect, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FiUsers, FiTrendingUp, FiAlertCircle, FiPhone } from "react-icons/fi";
import { api } from "../services/api";
import PageHeader from "./ui/PageHeader";
import StatCard from "./ui/StatCard";
import DataCard from "./ui/DataCard";
import StatusBadge from "./ui/StatusBadge";
import LoadingState from "./ui/LoadingState";
import AlertBanner from "./ui/AlertBanner";

const DashboardWidgets = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .getDashboardHome()
      .then(setData)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingState message="Loading dashboard..." />;
  if (error) return <AlertBanner type="danger" message={error} />;

  return (
    <div>
      <PageHeader
        title="Dashboard"
        subtitle="Real-time overview of bill payments across India"
      />

      <Row className="g-3 mb-4">
        <Col sm={6} xl={3}>
          <StatCard
            icon={<FiUsers />}
            label="Active Users"
            value={data.activeUsers}
            accent="#6366f1"
            iconBg="#eef2ff"
          />
        </Col>
        <Col sm={6} xl={3}>
          <StatCard
            icon={<FiTrendingUp />}
            label="Revenue This Month"
            value={data.monthlyRevenue}
            accent="#10b981"
            iconBg="#d1fae5"
          />
        </Col>
        <Col sm={6} xl={3}>
          <StatCard
            icon={<FiAlertCircle />}
            label="Alerts & Tickets"
            value={`${data.pendingAlerts} / ${data.openTickets}`}
            sub="Alerts · Open tickets"
            accent="#f59e0b"
            iconBg="#fef3c7"
          />
        </Col>
        <Col sm={6} xl={3}>
          <StatCard
            icon={<FiPhone />}
            label="Support Calls"
            value={data.openCalls}
            sub="Open follow-ups"
            accent="#0ea5e9"
            iconBg="#e0f2fe"
          />
        </Col>
      </Row>

      <div className="insight-banner">
        <span>
          Top category: <strong>{data.topBillCategory}</strong> — highest bill payment volume
        </span>
        <Link to="/bill-payments">View all services →</Link>
      </div>

      <DataCard title="Recent Bill Payments">
        <Table responsive className="billr-table mb-0">
          <thead>
            <tr>
              <th>Txn ID</th>
              <th>Customer</th>
              <th>Bill Type</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data.recentTransactions.map((txn) => (
              <tr key={txn.id}>
                <td><code style={{ fontSize: "0.8rem", color: "#6366f1" }}>{txn.id}</code></td>
                <td>{txn.user}</td>
                <td>{txn.type}</td>
                <td><strong>{txn.amount}</strong></td>
                <td><StatusBadge status={txn.statusKey} label={txn.status} /></td>
              </tr>
            ))}
          </tbody>
        </Table>
      </DataCard>
    </div>
  );
};

export default DashboardWidgets;
